import { DocumentStatusResource } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';
import { buildHeadersFromDocumentParams } from '../logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../types/DocumentParams';

export const getDocumentStatus = async (
  constructGet: ConstructGet,
  documentParams: DocumentParams,
  documentId: string,
): Promise<NonPaginatedResponse<DocumentStatusResource> | undefined> =>
  constructGet<NonPaginatedResponse<DocumentStatusResource>>(
    `${DOCUMENTS_BASE_PATH}/${documentId}/status/${documentParams.definition}`,
    {
      headers: buildHeadersFromDocumentParams(documentParams),
    },
  );
